<template>
  <v-card class="tabledetails1" >
				<!--<v-toolbar    dense flat  >
				  <v-toolbar-title>
					<span class="headline black--text font-weight-thick">Live Kafka Topic Stream</span>
				  </v-toolbar-title>
				  <v-spacer></v-spacer>
              		<v-btn     flat  v-on:click="directsubscribe($route.params.id)"   ><v-icon>refresh</v-icon> Alert</v-btn>
				</v-toolbar> 
	-->
<v-card-text class="p-1 m-0">  

					<v-list  >
                          <template v-for="(flist, index) in kafadata" v-if="index<=7">
                             <v-list-tile     :key="`ev${index}`"   avatar     >
                                <v-list-tile-avatar>
                                   <v-avatar color="teal" size="38px" >
                                      <span class="white--text title font-weight-bold">{{ flist.itemtype.charAt(0).toUpperCase() }}</span>
                                    </v-avatar>
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                   <v-list-tile-title>{{ flist.title }}</v-list-tile-title>
                                    <v-list-tile-sub-title>{{ flist.itemtype }}</v-list-tile-sub-title>
                                   <v-list-tile-sub-title>{{ flist.created }}</v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                   <v-btn icon ripple :to="`/contacts/info/${flist.id}`">
                                      <v-icon color="grey lighten-1">info</v-icon>
                                   </v-btn>
                                </v-list-tile-action>
                             </v-list-tile>
                             <v-divider  v-if="index + 1 < kafadata.length"   :key="`dfcc${index}`" class="m-0 p-0" ></v-divider>
                          </template>
                       </v-list>

				 </v-card-text> 
			 </v-card>
</template>
<script>
import { mapGetters } from 'vuex';
import moment from 'moment'
import io from 'socket.io-client';

 
export default {
	name: 'DashBoxService',
	 filters: {
   	    fromDate3(date) {			
			return (new Date(date) + "").substr(0, 24).toISOString();
			//return  '';
   		},fromDate2(date) {			
			return moment.unix(new Date(date)).format('D MMM YYYY');
			//return  '';
   		},fromNow(timestamp) {
			if(timestamp){
			 return (new Date(timestamp) + "").substr(0, 24)
   				//return    moment(timestamp , 'X').format('yyyy-MM-dd HH:mm:ss');
			}else{
				return '-';
			}
   		} 
	},mounted() {
	     
		 
		 
			
	
	},data() {
		return {
			 d:'1601370823487',
			 socket : '',
			 valid: true, 
			 alertstatus:false,
			 //kdata:[],
			 search: '',
			headers: [
			 
			  { text: 'Title#', 	align: 'left', sortable: false, value: 'title'  },
			  { text: 'Itemtype#', 	align: 'left', sortable: false, value: 'itemtype'  },
			  //{ text: 'Type#', 	align: 'left', sortable: false, value: 'type'  },
			  //{ text: 'Message', value: 'message' },
			  { text: 'Offset', value: 'offset' },
			  { text: 'Created', value: 'created' } ,
			   //{ text: 'Correlation#', 	align: 'left', sortable: false, value: 'correlation'  },
			  //{ text: 'Transaction#', 	align: 'left', sortable: false, value: 'transaction'  },
			], 
			desserts2: [
			  {
				correlation: 'Frozen Yogurt',
				transaction: 159,
				message: 6.0,
				offset: 24,
				created: 4.0 
			  },
			   
			]
			 
		}
	  },
	components: {
	 
	},
	watch: {
		
		
    },
	created: function(){	
		var vm =this;
		//vm.socket=io("http://localhost:5000");
		 
		
		 
	},
	methods: {
		 	
		getkafka:  function(){
		
		
			 
		},isEmpty: function (obj) {
		  for(var prop in obj) {
			if(obj.hasOwnProperty(prop)) {
			  return false;
			}
		  }
		  return JSON.stringify(obj) === JSON.stringify({});
		},	
		
		 directsubscribe(topic){
				var itemid=topic;
				topic='phone-topic'+topic;
				//var groupid=this.user.uid+'-newmgroup';
				var groupid=this.user.uid+itemid+'-newmgroup';
				///this.$store.commit('setPageload', true)
				var uid=this.$store.state.user.uid;
				var vm=this;
				 axios.get(`${window.endpoint}/gatewayc2/kafka-phone-subscribe/`+topic+`/`+groupid+`/`+uid+`/`+itemid, {} ).then(dataset => {	
				 				
					 //vm.$store.commit('setPageload', false);
					 vm.alertstatus=true;
					 vm.$store.state.snack = true;
					 vm.$store.state.snackColor = 'info';
					 vm.$store.state.snackText = '.Subscribed to '+topic+'';
					 
					 
				}).catch(err => { 
					// vm.$store.commit('setPageload', false)
				})
			 
			 
		 } 
		 
		
	 
    },
    computed: {
		 kafadata() {
			 return this.$store.state.kdata.reverse();
		 }, 
		 maxDate() {
			 return moment().add('years', 1).format('YYYY-MM-DD')
		 },
		 minDate() {
			 return moment().format('YYYY-MM-DD')
		},		
		user () {
			if(this.$store.state.user){
				return this.$store.state.user;
			}else{
				return '';
			}
		} 
		
		
	}
}
</script>


<style>
[v-cloak] {
	display: none;
}

</style>




// WEBPACK FOOTER //
// src/components/Voip/RecentKafkaPop.vue